import { createContext } from 'react';
export const ModalContext = createContext(undefined);
ModalContext.displayName = 'ModalContext';
//# sourceMappingURL=ModalContext.js.map